import { apiProxy, Payload } from './proxy.services';

const TELEPHONY_API = process.env.VUE_APP_TELEPHONY_API;

export default {
    async setVirtualNumber(sellerID) {

        const options = new Payload(`${TELEPHONY_API}/dealers/CL-SELLER-${sellerID}/used/virtualNumber`, 'POST', {
            "areaCode": "2",
            "dialingCode": "+56",
            "phoneType": "Landline"
          });

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            throw new Error(error);
        }

    }
}; 